import {Box, Input, VStack, Text, Spinner, Image} from '@chakra-ui/react';
import { Button } from '@/components/ui';
import React from 'react';
import {useForm} from "@/uses/useForm";
import {useUser} from "@/contexts/userContext";
import {useLanguage} from "@/contexts/languageContext";
import logo from '@/assets/images/logo-cartouche-secondary.png'

export const Login = () => {

    const { t } = useLanguage();
    const {login} = useUser();
    const {formData, getFormErrors, formFieldErrors, state, handleInputChange, handleFormSubmit} = useForm(
        {email: '', password: ''},
        {
            email: {
                required: {
                    value: true,
                    message: t('errors.pleaseFillField')
                }
            },
            password: {
                required: {
                    value: true,
                    message: t('errors.pleaseFillField')
                }
            },
        }
    );

    return (
        <VStack flex={1} gap="5vh" bg="primary.300" py="1rem" w="100%" px={{ base: '20vw', md: '20vw', lg: '30vw'}}>
            <Box flex={1}/>
            <VStack>
                <Image src={logo} alt="Logo" w="auto" h="250px" />
                <Text fontSize="xl" fontWeight="bold" textAlign="center" color="secondary.500">{ t('misc.login') }</Text>
                <Text fontSize="sm" textAlign="center" color="secondary.500">{t('welcomeSentence')}</Text>
            </VStack>
            <VStack gap="2.5vh" w="100%">
                <Input
                    label={t('fields.email')}
                    value={formData.email}
                    onChange={e => handleInputChange('email', e.target.value)}
                    placeholder={t('fields.email')}
                    variant="inverted"
                    bg="white"
                    color="secondary.500"
                />
                <Input
                    label={t('fields.password')}
                    type="password"
                    value={formData.password}
                    onChange={e => handleInputChange('password', e.target.value)}
                    placeholder={t('fields.password')}
                    variant="inverted"
                    bg="white"
                    color="secondary.500"
                />
                {formFieldErrors.email && <Text color="red">{formFieldErrors.email}</Text>}
                {formFieldErrors.password && <Text color="red">{formFieldErrors.password}</Text>}
                {getFormErrors()}
                {state === 0 ? <Spinner/> : (
                    <Button
                        disabled={state === 0}
                        onClick={() => handleFormSubmit(login, () => null)}
                        variant="primary"
                        style={{ padding:".8rem 2rem" }}
                        borderRadius=".35rem"
                    >
                        {t('misc.logIn')}
                    </Button>
                )}
                <Button
                    bg="transparent"
                    fontSize="sm"
                    color="secondary"
                    onClick={() => { window.location.href = '/reset-password'; }}
                >
                    {t('resetPassword.forgot')}
                </Button>
            </VStack>
            <Box flex={1}/>
        </VStack>
    );
};

export default Login;
